import KnowYourCustomers from './KnowYourCustomers';

export default KnowYourCustomers;
